import { Phone } from "lucide-react";

export const MobileDock = () => (
  <div
    data-testid="mobile-emergency-dock"
    className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0A0D12]/95 px-3 pt-2.5 backdrop-blur-xl md:hidden"
    style={{ paddingBottom: "calc(0.625rem + env(safe-area-inset-bottom))" }}
  >
    <a
      href="tel:+390685902421"
      data-testid="mobile-dock-call-button"
      className="flex w-full items-center justify-center gap-2.5 rounded-full bg-amber-400 py-4 text-base font-extrabold uppercase tracking-wide text-zinc-950 shadow-[0_0_28px_rgba(245,158,11,0.35)]"
    >
      <Phone className="h-5 w-5" />
      CHIAMA ORA — 06 8590 2421
    </a>
  </div>
);
